import http from '@/environment/environment';
import Token from '@/_models/Token';

export class TokenService
{
    async getTokenListByWalletAddress(walletAddress: string): Promise<Token[]> {
        const tokens = await http.get(`wallets/${walletAddress}/tokens?ignoreExternal=false`);
        return tokens.data;
    }
}